import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Grid } from '@mui/joy';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import './ClassificationFormStyle.css';
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import { TbFileDescription } from 'react-icons/tb';
import CustomTextArea from '../../../../Components/custom_components/CustomTextArea/CustomTextArea';
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import { FaHashtag } from 'react-icons/fa';
import { statusOptions } from '../../../../utils/constants';

function ClassificationForm({ handleClassificationSave, isButtonDisabled, formIntialValues, id }) {
  const formik = useFormik({
    initialValues: formIntialValues,
    validationSchema: Yup.object({
      ClassificationName: Yup.string().required('Classification name is required'),
      Status: Yup.string().required('Status is required'),
    }),
    enableReinitialize: true,
    onSubmit: (values) => {
      handleClassificationSave(values, id);
    },
  });

  // Reset handler
  const handleReset = () => {
    formik.setFieldValue('Status', 1);
    formik.setFieldValue('ClassificationName', '');
    formik.setFieldValue('Description', '');
    formik.setTouched({
      ClassificationName: false,
      Status: false,
      Description: false,
    });
  };

  return (
    <div className="classification-form-container">
      <Grid container spacing={2}>
        {/* LEFT SIDE */}
        <Grid item xs={12} md={6}>
          <div className="classification-mid-form-container">
            <div className="classification-label-container">
              <span className="label">
                Classification Name <span className="classification-label-required">*</span>
              </span>
            </div>
            <div className="classification-textfield-container">
              <CustomTextFieldWithIcon
                id="ClassificationName"
                name="ClassificationName"
                placeholder="Enter classification name"
                value={formik.values.ClassificationName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.ClassificationName && Boolean(formik.errors.ClassificationName)}
                helperText={formik.touched.ClassificationName && formik.errors.ClassificationName}
              />
            </div>
          </div>
        </Grid>

        {/* RIGHT SIDE */}
        {id && (
          <Grid item xs={12} md={6}>
            <div className="classification-mid-form-container">
              <div className="classification-label-container">
                <span className="label">
                  Status <span className="classification-label-required">*</span>
                </span>
              </div>
              <div className="classification-textfield-container">
                <CustomSelectDropdown
                  name="Status"
                  placeholder="Select Status"
                  options={statusOptions}
                  value={statusOptions?.find(
                    (option) => option?.value === formik?.values?.Status
                  ) || ''}
                  onChange={(selectedOption) => {
                    formik.setFieldValue(
                      'Status',
                      selectedOption ? selectedOption.value : ''
                    );
                  }}
                  onBlur={formik.handleBlur}
                  error={formik.touched.Status && Boolean(formik.errors.Status)}
                  helperText={formik.touched.Status && formik.errors.Status}
                  isClearable={false}
                  width="100%"
                />
              </div>
            </div>
          </Grid>
        )}

        <Grid item xs={12} md={6}>
          {/* Classification Description */}
          <div className="classification-label-container">
            <span className="label">
              Description <span className="classification-label-required"></span>
            </span>
          </div>
          <div className="classification-textfield-container">
            <CustomTextArea
              id="Description"
              name="Description"
              placeholder="Enter description"
              value={formik.values.Description}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              rows={5}
            />
          </div>
        </Grid>
      </Grid>

      <div className="classification-form-action-buttons">
        <ActionButton onClick={handleReset} label={`Reset`} btnType={`outlined`} />
        <ActionButton
          onClick={() => formik.handleSubmit()}
          btnDisable={isButtonDisabled}
          label={`Save`}
          btnType={`primary`}
        />
      </div>
    </div>
  );
}

export default ClassificationForm;
